import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomNavbar from "./CustomNavbar";
import { Link } from "react-router-dom";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const API_URL = getApiUrl("/Authentication/permissions/"); // Adjust as per your Django server

const PermissionsPage = () => {
  const [permissions, setPermissions] = useState([]);
  const [newPermission, setNewPermission] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch permissions
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(API_URL)
      .then((response) => {
        const sortedPermissions = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setPermissions(sortedPermissions);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError("Failed to load permissions");
        setIsLoading(false);
      });
  }, []);

  // Create permission
  const handleCreate = () => {
    if (!newPermission.trim()) return;

    setIsLoading(true);
    axios
      .post(API_URL, { name: newPermission })
      .then((response) => {
        setPermissions([...permissions, response.data]);
        setNewPermission("");
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error creating permission:", error);
        setError("Failed to create permission");
        setIsLoading(false);
      });
  };

  // Update permission
  const handleUpdate = (id) => {
    if (!editName.trim()) return;

    setIsLoading(true);
    axios
      .put(`${API_URL}${id}/`, { name: editName })
      .then((response) => {
        setPermissions(
          permissions.map((p) => (p.id === id ? response.data : p))
        );
        setEditId(null);
        setEditName("");
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error updating permission:", error);
        setError("Failed to update permission");
        setIsLoading(false);
      });
  };

  // Delete permission
  const handleDelete = (id) => {
    // if (!confirm("Are you sure you want to delete this permission?")) return;

    setIsLoading(true);
    axios
      .delete(`${API_URL}${id}/`)
      .then(() => {
        setPermissions(permissions.filter((p) => p.id !== id));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting permission:", error);
        setError("Failed to delete permission");
        setIsLoading(false);
      });
  };

  return (
    <div style={{ display: "flex" }}>
      <CustomNavbar />
      <div
        className=" mx-auto p-6 bg-white rounded-lg shadow-md"
        style={{ width: "80vw", margin: "10px auto" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="text-2xl font-bold text-blue-500 mb-6">
            Permissions Management
          </h2>
          {/* <Link to="AssignUserPermissionPage"></Link> */}
          <Link to="/AssignUserPermissionPage">
            <button
              className="bg-blue-500 p-2 text-white hover:bg-blue-800"
              style={{ borderRadius: "5px" }}
            >
              Assign Permissions
            </button>
          </Link>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {error}
            <button
              className="float-right text-red-700 hover:text-red-900"
              onClick={() => setError(null)}
            >
              &times;
            </button>
          </div>
        )}

        {/* Create Permission */}
        <div className="mb-6">
          <div className="flex gap-2">
            <input
              type="text"
              value={newPermission}
              onChange={(e) => setNewPermission(e.target.value)}
              placeholder="Enter new permission"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleCreate}
              disabled={isLoading || !newPermission.trim()}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Adding..." : "Add"}
            </button>
          </div>
        </div>

        {/* Permissions List */}
        {isLoading && permissions.length === 0 ? (
          <div className="flex justify-center py-4">
            <div className="animate-pulse text-gray-500">
              Loading permissions...
            </div>
          </div>
        ) : permissions.length === 0 ? (
          <div className="text-center py-4 text-gray-500">
            No permissions found
          </div>
        ) : (
          <ul className="divide-y divide-gray-200">
            {permissions.map((permission) => (
              <li key={permission.id} className="py-4">
                <div className="flex items-center justify-between">
                  {editId === permission.id ? (
                    <div className="flex flex-1 items-center gap-2">
                      <input
                        type="text"
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <button
                        onClick={() => handleUpdate(permission.id)}
                        disabled={isLoading || !editName.trim()}
                        className="px-3 py-1 bg-green-500 text-white rounded-md text-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setEditId(null);
                          setEditName("");
                        }}
                        className="px-3 py-1 bg-gray-200 text-gray-800 rounded-md text-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <>
                      <span className="text-gray-800 font-medium flex-1">
                        {permission.name}
                      </span>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => {
                            setEditId(permission.id);
                            setEditName(permission.name);
                          }}
                          className="px-3 py-1 bg-gray-100 text-gray-700 rounded-md text-sm hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(permission.id)}
                          className="px-3 py-1 bg-red-100 text-red-700 rounded-md text-sm hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500"
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PermissionsPage;
